/*
  This is helper to limit amount data that gets pushed into
  `window.history.state`. Push too much data and Fx will throw
  `NS_ERROR_ILLEGAL_VALUE` error. Plus there's serializing penalty everytime
  state is changed.
 */

const defaultTitle = 'state';

const copyWithoutBase = (base, stateObj) => {
  const copy = Object.assign({}, stateObj);
  Object.keys(base).forEach(k => delete copy[k]);
  return copy;
};

const updateState = (url, base) => stateObj => {
  const copy = copyWithoutBase(base, stateObj);
  window.history.replaceState(copy, defaultTitle, url);
};

const saveState = (url, base) => stateObj => {
  const copy = copyWithoutBase(base, stateObj);
  window.history.pushState(copy, defaultTitle, url);
};

const goBack = base => () => {
  window.history.back();
  const { state } = window.history;
  return [state, Object.assign({}, base, window.history.state)];
};

/* Curries functions with passed arguments. StaticData is removed from `stateObj`
   before it's passed to `window.history.state`.
 */
// HistoryAPI :: (String, Object) -> HistoryAPI
function HistoryAPI(url, staticData) {
  return {
    updateState: updateState(url, staticData),
    saveState: saveState(url, staticData),
    goBack: goBack(staticData),

    goBackAsync () {
      return new Promise(resolve => {
        const listener = () => {
          window.removeEventListener('popstate', listener);
          const { state } = window.history;
          resolve([state, Object.assign({}, staticData, state)]);
        };
        window.addEventListener('popstate', listener);
        window.history.back();

      });
    }
  };
}

module.exports = HistoryAPI;
